<template>
  <div>
    <el-select
      :style="styles"
      v-model="val"
      filterable
      :multiple="multiple"
      :placeholder="placeholder"
      clearable
      @clear="handlerClear"
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item[valueType]"
        :disabled="item.disabled"
      >
        <span style="float: left">{{ item.label }}</span>
        <span v-if="item.showSpan" style="float: right; color: #8492a6; font-size: 13px"
          >已封禁</span
        >
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { getDriverOrCarList } from '@/api/public'
  import { validatorTypes, getLable, getDisabled, getShowSpan, getValue } from './utils.driver-car'
  import { cloneDeep } from 'lodash-es'
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComDriverCarSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      // 组件类型，car/driver/all,all表示车辆司机(已绑定)，以车辆id为主
      type: {
        type: String,
        default: 'driver'
      },
      // 根据线路ID查询司机、车辆
      lineId: {
        type: [String, Number],
        default: ''
      },
      // 根据供应商ID查询司机或车辆
      merchantId: {
        type: [String, Number],
        default: ''
      },
      // 展示的label,driver,car,phone
      showLabel: {
        type: [Array, String],
        default: () => 'driver',
        validator: validatorTypes
      },
      // 是否展示已封禁司机或车辆
      showDisabled: {
        type: Boolean,
        default: false
      },
      // 是否可选已封禁司机或车辆
      isCheckDisabled: {
        type: Boolean,
        default: false
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择司机'
      },
      styles: {
        type: Object,
        default: () => {}
      },
      // 值的类型，默认为value，可选label
      valueType: {
        type: String,
        default: 'value'
      }
    },
    data() {
      return {
        val: undefined,
        list: []
      }
    },
    computed: {
      options() {
        let l = cloneDeep(this.list)
        if (this.type === 'all') {
          l = l.filter((item) => item.driverId)
        }
        if (this.showDisabled) {
          return l
        }
        l = l.filter((item) => !item.disabled)
        return l
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      },
      merchantId: {
        handler(newVal, oldVal) {
          this.getList()
        }
      },
      lineId: {
        handler(newVal, oldVal) {
          this.getList()
        }
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        let type = 1
        if (this.type !== 'driver') {
          type = 2
        }
        const params = {
          type,
          lineId: this.lineId,
          merchantId: this.merchantId
        }
        const { code, data } = await getDriverOrCarList(params)
        if (code !== 0) {
          return
        }
        const records = data
        if (!Array.isArray(records)) {
          return
        }
        const l = records.map((item) => {
          const obj = {
            value: getValue(item, this.type),
            label: getLable(item, this.showLabel, this.type),
            disabled: getDisabled(item, this.isCheckDisabled),
            showSpan: getShowSpan(item, this.isCheckDisabled),
            ...item
          }
          return obj
        })
        this.list = l
      },
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item[this.valueType])
        this.$emit('change', item)
      },
      handlerClear() {
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="scss" scoped></style>
